var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1667 16.6667L13.7917 13.2917M13.7917 13.2917C14.3334 12.75 14.7631 12.1069 15.0562 11.3991C15.3494 10.6913 15.5003 9.93275 15.5003 9.16667C15.5003 8.40059 15.3494 7.642 15.0562 6.93424C14.7631 6.22647 14.3334 5.58337 13.7917 5.04167C13.25 4.49997 12.6069 4.07026 11.8991 3.7771C11.1913 3.48393 10.4328 3.33304 9.66667 3.33304C8.90059 3.33304 8.142 3.48393 7.43424 3.7771C6.72647 4.07026 6.08337 4.49997 5.54167 5.04167C4.44765 6.13569 3.83304 7.61949 3.83304 9.16667C3.83304 10.7138 4.44765 12.1977 5.54167 13.2917C6.63569 14.3857 8.11949 15.0003 9.66667 15.0003C11.2138 15.0003 12.6977 14.3857 13.7917 13.2917V13.2917Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.aa074932775be64497130ff4553b751c.svg";
export { ForwardRef as ReactComponent };